<template>
  <el-dialog
    title="大OEM代理信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="140px"
      size="small"
    >
      <el-form-item v-if="formEdit2"
        prop="userCode"
        label="登陆名"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.userCode"></el-input>
      </el-form-item>
      <el-form-item
        prop="legal"
        label="姓名"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.legal"></el-input>
      </el-form-item>
      <el-form-item
        prop="userName"
        label="公司/个人"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.userName"></el-input>
      </el-form-item>
      <el-form-item
        prop="mobileNo"
        label="手机"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.mobileNo"></el-input>
      </el-form-item>
      <el-form-item
              prop="wx_appid"
              label="微信小程序appid"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.wx_appid"></el-input>
      </el-form-item>
      <el-form-item
              prop="prov_cd"
              label="省"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.prov_cd"
                placeholder="请选择省"
                @change="currentSel(form.prov_cd)"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="city"
              label="市"
      >
        <el-select
                class="filter-item"
                v-model="form.city"
                placeholder="请选择市"
                @change="currentSel2(form.city)"
        >
          <el-option
                  v-for="item in typeOptions2"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="areaid"
              label="区"
      >
        <el-select
                class="filter-item"
                v-model="form.areaid"
                placeholder="请选择区"
        >
          <el-option
                  v-for="item in typeOptions3"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="compaddress"
              label="地址"
      >
        <el-input v-model="form.compaddress"></el-input>
      </el-form-item>

      <el-form-item
              prop="contractstdate"
              label="合同开始日期"
      >

        <el-date-picker
                v-model="form.contractstdate"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>

      </el-form-item>

      <el-form-item
              prop="contractendate"
              label="合同结束日期"
      >
        <el-date-picker
                v-model="form.contractendate"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
export default {
  name: "agentEditForm",
  props: {
      agent: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
        formEdit2: true,
      loading: false,
      dialogVisible: false,
        pickerOptions: {}, // 日期设置对象
      form: {
          businessid: "",
          businessname: "",
          sort_id: ""
      },
        typeOptions: [],
        typeOptions2: [],
        typeOptions3: []
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {

    dialogOpen() {
      this.$refs.form.resetFields();
        var formData2 = new FormData() // 声明一个FormData对象
        agentService.getProvcd(formData2).then(data => {
            this.typeOptions=data;
        });
        if(this.agent.city){
            this.currentSel(this.agent.prov_cd);
        }
        if(this.agent.areaid){
            this.currentSel2(this.agent.city);
        }
      if (this.agent.userId) {
       // userService.getUser(this.user.id).then(data => {
          let form = {};
          form.userCode = this.agent.userCode;
          form.legal = this.agent.legal;
          form.userName = this.agent.userName;
          form.mobileNo = this.agent.mobileNo;
          form.wx_appid = this.agent.wx_appid;
          form.prov_cd = this.agent.prov_cd;
          form.city = this.agent.city;
          form.areaid = this.agent.areaid;
          form.compaddress = this.agent.compaddress;
          form.contractstdate = this.agent.contractstdate;
          form.contractendate = this.agent.contractendate;
          this.form = form;
       // });
          this.formEdit = true;
          this.formEdit2=false;
      } else {
          this.formEdit = true;
          this.formEdit2=true;
        this.form = {};
      }
    },
      currentSel(val) {
          if (this.agent.userId) {
              this.form.city = "";
              this.form.areaid = "";
          }
          this.typeOptions2=[];
          var formData2 = new FormData() // 声明一个FormData对象

          formData2.append('type','city')
          formData2.append('areaid',val)
          agentService.getProvcd(formData2).then(data => {
              this.typeOptions2=data;
          });
      },
      currentSel2(val) {
          this.typeOptions3=[];
          var formData2 = new FormData() // 声明一个FormData对象
          formData2.append('type','area')
          formData2.append('areaid',val)
          agentService.getProvcd(formData2).then(data => {
              this.typeOptions3=data;
          });
      },
    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
            if (this.agent.userId) {
                this.loading = true;
                agentService.saveAgent({ ...this.form,agentid:util.cookies.get('agentid'), id:this.agent.userId ,agentids:this.agent.agentid,dl_type:'-1',xt_id:util.cookies.get('xt_id')})
                    .then(data => {
                        this.loading = false;
                        this.dialogVisible = false;
                        this.$emit("submit");
                    });
            }else{
            userService
                .getCheckUser({userCode: this.form.userCode})
                .then(data2 => {
                    console.log("=========data2:"+data2);
                    if (data2 == "true") {
                        this.loading = true;
            agentService.saveAgent({ ...this.form,agentid:util.cookies.get('agentid'), id:this.agent.userId ,agentids:this.agent.agentid,dl_type:'-1',xt_id:util.cookies.get('xt_id')})
                            .then(data => {
                                this.loading = false;
                                this.dialogVisible = false;
                                this.$emit("submit");
                            });
                    } else {
                        this.$message('该账号已存在,请更换账号试试');
                    }
                });
            }
        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

